import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";

import { getViewHtmlId } from "../../focusHandling/sagas";

import { confirmResponse } from "../actions";
import { isInvitationConfirmModalData } from "../types";

export const InvitationConfirmModal: View.ViewComponent = function InvitationConfirmModal(props) {
	const { activityId } = props;
	const dispatch = useDispatch();
	const data = useSelector(ActivitySelectors.data(activityId));
	const modalData = isInvitationConfirmModalData(data)
		? data
		: {
				title: "Bestätigen",
				message: "Möchten Sie diese Aktion wirklich ausführen?",
				buttonLabel: "Bestätigen"
			};

	const onCancel = React.useCallback(() => {
		dispatch(confirmResponse({ confirmed: false }));
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activityId]);

	const onConfirm = React.useCallback(() => {
		dispatch(confirmResponse({ confirmed: true }));
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activityId]);

	return (
		<ModalNotification
			id={getViewHtmlId(activityId)}
			variant="warning"
			onClose={onCancel}
			title={modalData.title}
			footer={
				<ButtonGroup alignment="right">
					<Button label="Abbrechen" secondary onClick={onCancel} />
					<Button label={modalData.buttonLabel} destructive primary onClick={onConfirm} />
				</ButtonGroup>
			}
		>
			<p>{modalData.message}</p>
		</ModalNotification>
	);
};
